import React from "react";
import { CheckCircle2, Circle, Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtBytes, fmtDT } from "@/lib/platform";
import { downloadEvidence } from "@/lib/rights";
import { Panel } from "@/components/rights/RightsBadges";
import { EvidenceUploadButton } from "@/components/rights/EvidenceUploadButton";

export const EvidencePanel = ({ r, meta, canEdit, onChanged }) => {
  const editable = canEdit && r.status !== "CLOSED";
  const approved = r.approvals.some((a) => a.status === "Approved");
  return (
    <Panel eyebrow="Evidence pack" title="Request evidence" testId="evidence-panel">
      <div className="space-y-5">
        {Object.entries(meta.evidence_categories).map(([k, label]) => {
          const files = r.evidence.filter((e) => e.category === k);
          const done = files.length > 0 || (k === "CLOSURE_APPROVAL" && approved);
          return (
            <div key={k} data-testid={`evidence-slot-${k.toLowerCase()}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  {done ? <CheckCircle2 className="w-4 h-4 text-emerald-600" /> : <Circle className="w-4 h-4 text-slate-300" />}
                  <span className="text-sm font-semibold text-[#003366]">{label}</span>
                  <span className="text-[10px] font-mono text-slate-400" data-testid={`evidence-count-${k.toLowerCase()}`}>{files.length}</span>
                  {k === "CLOSURE_APPROVAL" && approved && <span className="text-[10px] text-emerald-700">· approval recorded in the approval engine</span>}
                </div>
                {editable && <EvidenceUploadButton requestId={r.id} category={k} onUploaded={onChanged} label="Upload"
                                                   testId={`evidence-upload-${k.toLowerCase()}`} />}
              </div>
              {files.length > 0 && (
                <ul className="mt-2 ml-6 divide-y divide-slate-100 border border-slate-100 rounded-lg">
                  {files.map((e) => (
                    <li key={e.id} className="flex items-center gap-3 px-3 py-2 text-xs" data-testid={`evidence-file-${e.id}`}>
                      <span className="font-mono text-slate-400">{e.reference_number}</span>
                      <span className="font-medium text-[#003366] truncate flex-1">{e.file_name}</span>
                      <span className="text-slate-500 hidden md:inline">{fmtBytes(e.file_size)} · {e.uploaded_by} · {fmtDT(e.uploaded_at)}</span>
                      <Button size="icon" variant="ghost" className="h-7 w-7" onClick={() => downloadEvidence(e.id)}
                              data-testid={`evidence-download-${e.id}`}><Download className="w-3.5 h-3.5" /></Button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </div>
    </Panel>
  );
};
